"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_BRUTE_FORCE_KNAPSACK_ITEM_COUNT = exports.finleyAutomatedUser = exports.finleyAdminUser = exports.finleyAutomatedActor = exports.finleyAdminSpecialUserId = exports.finleyAutomatedProcessId = exports.finleyOrganizationSlug = exports.specialOrganizationIds = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
var specialOrganizationIds;
(function (specialOrganizationIds) {
    specialOrganizationIds.finley = '00000000-0000-0000-0000-66696e6c6579';
})(specialOrganizationIds = exports.specialOrganizationIds || (exports.specialOrganizationIds = {}));
exports.finleyOrganizationSlug = 'finley';
exports.finleyAutomatedProcessId = '506f7765-7265-6442-7950-616e64615850';
exports.finleyAdminSpecialUserId = '0046696e-6c65-7941-646d-696e55736572';
// Finley Automated Process actor for createEvent
exports.finleyAutomatedActor = {
    actorId: exports.finleyAutomatedProcessId,
    actorType: 'finleyAutomated',
};
/**
 * Finley Manual Process special admin user for createEvent
 * we intend to remove this user, as each finley internal user should have their own authenticated user and its own authorization, when IAM is fully ready with AA
 * */
exports.finleyAdminUser = {
    id: exports.finleyAdminSpecialUserId,
    organizationId: specialOrganizationIds.finley,
    /**
     * borrowerKey and borrowerName are placeholders until a userType allows for special, to link Finley Org
     * currently the frontend will not show extended organization information for users
     * TODO: Update admin user with correct organization information
     */
    email: 'support@finleycms.com',
    firstName: 'Finley',
    isActive: true,
    lastName: 'Admin',
    roleType: 'ADMIN',
    userType: 'SUPER_USER',
    created_at: new Date('2022-05-03'),
    updated_at: new Date('2022-05-03'),
};
/**
 * Finley Automated Process special admin user for createEvent
 * we intend to remove this user, as each finley internal user should have their own authenticated user and its own authorization, when IAM is fully ready with AA
 * */
exports.finleyAutomatedUser = {
    id: exports.finleyAutomatedProcessId,
    organizationId: '00000000-0000-0000-0000-66696e6c6579',
    /**
     * borrowerKey and borrowerName are placeholders until a userType allows for special, to link Finley Org
     * currently the frontend will not show extended organization information for users
     * TODO: Update admin user with correct organization information
     */
    email: 'support@finleycms.com',
    firstName: 'Finley',
    isActive: true,
    lastName: '',
    roleType: 'ADMIN',
    userType: 'SUPER_USER',
    created_at: new Date('2022-05-03'),
    updated_at: new Date('2022-05-03'),
};
const bankDataProviderKeys = {
    plaid: 'plaid',
    teller: 'teller',
    manualDashboard: 'manualDashboard',
    manualS3Upload: 'manualS3Upload',
};
const verificationAgentSlugs = {
    carmel: 'carmel',
    systemsAndServicesTechnologies: 'systemsAndServicesTechnologies',
    xyzVerifications: 'xyzVerifications',
    bancoActinver: 'bancoActinver',
    tecnologiaEnCuentas: 'tecnologiaEnCuentas',
};
const regExpTimeStr = /^([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])(\.\d{1,})?(([Z])|([+|-]([01][0-9]|2[0-3]):[0-5][0-9]))$/;
const regExpFullDateStr = /^\d{4}-\d{2}-\d{2}$/;
const regExpFullDateTimeStr = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
const borrowingBaseContributionAccountTypes = [
    finley_types_1.Bank.BorrowerAccountType.Collections,
    finley_types_1.Bank.BorrowerAccountType.PreFundingAccount,
    finley_types_1.Bank.BorrowerAccountType.PermittedInvestmentsAccount,
    finley_types_1.Bank.BorrowerAccountType.AccountIncludedInBorrowingBase,
];
const cashBalanceFeedContributionAccountTypes = [
    ...borrowingBaseContributionAccountTypes,
    finley_types_1.Bank.BorrowerAccountType.OtherReserveAccount,
];
// Stored as userType in DB
const userTypes = {
    BORROWER: 'BORROWER',
    CAPITAL_PROVIDER: 'CAPITAL_PROVIDER',
};
// manual uploader "uploads" files to local file system when running on development environment.
// we use "~/${DEVELOPMENT_S3_ROOT}/${bucket}/${key}" for such uploads.
// @makarand TODO:: exampnd other s3 (read/write) interactions to use the same location.
const DEVELOPMENT_S3_ROOT = 'local_s3';
const CURRENT_CREDIT_AGREEMENT_DOCUMENT_SCHEMA_VERSION = finley_types_1.CreditAgreement.DomainEntity.CreditAgreementSchemaVersion['1.0'];
/*
const PlaidEnvironments: PlaidEnvironment = {
  prod: 'https://production.plaid.com',
  sandbox: 'https://sandbox.plaid.com',
  development: 'https://development.plaid.com',
};

Update when ready for prod
*/
const plaidEnvForDeployEnv = {
    development: 'sandbox',
    stage: 'sandbox',
    prod: 'prod',
};
const plaidRedirectUriForPlaidEnv = {
    sandbox: undefined,
    development: 'https://app.stage.finleycms.com/settings/integrations',
    prod: 'https://app.finleycms.com/settings/integrations',
};
const plaidAssetReportTransactionDays = 180;
const closeOfBusinessHour = 17;
const MAX_TIMESTAMP = 8640000000000000; // milliseconds
const loanTapeType = {
    masterLoanTape: 'masterLoanTape',
    preassignedLoanTape: 'preassignedLoanTape',
    preassignedMasterLoanTape: 'preassignedMasterLoanTape',
};
const slackGroupToIdMap = {
    capMarkets: 'S02K4PWJEKT',
};
// max number of business days in the future that a loan tape is valid for
const maxFutureBusinessDaysReportingDate = 1;
exports.MAX_BRUTE_FORCE_KNAPSACK_ITEM_COUNT = 25;
/**
 * List of reserved markers used to parse identifier of Borrowing Base Pipeline Artifact Instance Identifier
 */
const S3_PATH_MARKER = `#s3Path:`;
const POSTGRES_COLUMN_MARKER = `#column:`;
const POSTGRES_ID_MARKER = `#id:`;
const DYNAMO_PARTITION_KEY_MARKER = `#partitionKey:`;
const DYNAMO_SORT_KEY_MARKER = `#sortKey:`;
const S3_IDENTIFIER_REGEX = `^${S3_PATH_MARKER}(.*)$`;
const PG_COLUMN_IDENTIFIER_REGEX = `^${POSTGRES_COLUMN_MARKER}(.*)${POSTGRES_ID_MARKER}.*$`;
const PG_ID_IDENTIFIER_REGEX = `^${POSTGRES_COLUMN_MARKER}.*${POSTGRES_ID_MARKER}(.*)$`;
/**
 * Common Styling Attributes
 */
const COLOR_HEX_CODES = {
    RED: '#FF0000',
    YELLOW: '#FFFF00',
    BLUE: '#0000FF',
};
exports.default = {
    bankDataProviderKeys,
    borrowingBaseContributionAccountTypes,
    cashBalanceFeedContributionAccountTypes,
    closeOfBusinessHour,
    CURRENT_CREDIT_AGREEMENT_DOCUMENT_SCHEMA_VERSION,
    DEVELOPMENT_S3_ROOT,
    finleyAdminSpecialUserId: exports.finleyAdminSpecialUserId,
    finleyAdminUser: exports.finleyAdminUser,
    finleyAutomatedActor: exports.finleyAutomatedActor,
    finleyAutomatedProcessId: exports.finleyAutomatedProcessId,
    finleyAutomatedUser: exports.finleyAutomatedUser,
    finleyOrganizationSlug: exports.finleyOrganizationSlug,
    maxFutureBusinessDaysReportingDate,
    MAX_TIMESTAMP,
    MAX_BRUTE_FORCE_KNAPSACK_ITEM_COUNT: exports.MAX_BRUTE_FORCE_KNAPSACK_ITEM_COUNT,
    plaidAssetReportTransactionDays,
    plaidEnvForDeployEnv,
    plaidRedirectUriForPlaidEnv,
    loanTapeType,
    regExpFullDateStr,
    regExpFullDateTimeStr,
    regExpTimeStr,
    slackGroupToIdMap,
    specialOrganizationIds,
    userTypes,
    verificationAgentSlugs,
    S3_PATH_MARKER,
    POSTGRES_COLUMN_MARKER,
    POSTGRES_ID_MARKER,
    DYNAMO_PARTITION_KEY_MARKER,
    DYNAMO_SORT_KEY_MARKER,
    COLOR_HEX_CODES,
    S3_IDENTIFIER_REGEX,
    PG_COLUMN_IDENTIFIER_REGEX,
    PG_ID_IDENTIFIER_REGEX,
};
//# sourceMappingURL=consts.js.map